module.exports = __webpack_public_path__ + "media/images/countrysquared/at-99e87549c8d61ad45b2f60065501791d.svg";